/* eslint-disable import/no-unresolved */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import { setFeatureSurveyLastShownAt } from 'rubriq/helpers/featureSurveyLastShownAt';
import { RUBRIQ_FEATURE_SURVEY_DELAY_MS, RUBRIQ_FEATURE_SURVEY_LINKS, RUBRIQ_FEATURES } from 'rubriq/constants';
import { T } from 'shared/helper/translate';
import { getLocale } from 'researcher/application/reducer';
var RubriqFeatureFeedbackToastNotification = function RubriqFeatureFeedbackToastNotification(_ref) {
  var downloadedDocumentIdentity = _ref.downloadedDocumentIdentity,
    lewisVersionForDocument = _ref.lewisVersionForDocument,
    feature = _ref.feature;
  var _useSelector = useSelector(getLocale),
    locale = _useSelector.locale;
  var _useSelector2 = useSelector(function (state) {
      return state;
    }),
    userIdentity = _useSelector2.user.identity;
  var generateSurveyLink = function generateSurveyLink() {
    var correctDelightedLink = RUBRIQ_FEATURE_SURVEY_LINKS[locale];
    var delightedSearchParams = new URLSearchParams({
      user_identity: userIdentity,
      origin: 'aje',
      feature: feature,
      submission_identity: downloadedDocumentIdentity
    });
    if (feature === 'editing') {
      delightedSearchParams.append('model_version', lewisVersionForDocument);
    }
    return "".concat(correctDelightedLink, "?").concat(delightedSearchParams.toString());
  };
  var ToastBody = function ToastBody(_ref2) {
    var closeToast = _ref2.closeToast;
    return /*#__PURE__*/React.createElement("div", {
      className: "rubriq-feature-feedback-toast d-flex flex-column"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rubriq-feature-feedback-toast-content d-flex flex-column"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rubriq-feature-feedback-toast-content-header d-flex align-items-center gap-2"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "rubriq-feature-feedback-toast-title flex-grow-1 m-0 lh-base"
    }, /*#__PURE__*/React.createElement(T, {
      source: "curie.feature-survey-title"
    })), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: closeToast,
      "aria-label": "close"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-x",
      fontWeight: 900
    }))), /*#__PURE__*/React.createElement("div", {
      className: "rubriq-feature-feedback-toast-content-body"
    }, /*#__PURE__*/React.createElement("p", null, feature === RUBRIQ_FEATURES.EDITING && /*#__PURE__*/React.createElement(T, {
      source: "curie.editing-survey-content"
    }), feature === RUBRIQ_FEATURES.TRANSLATION && /*#__PURE__*/React.createElement(T, {
      source: "curie.translation-survey-content"
    })))), /*#__PURE__*/React.createElement("div", {
      className: "d-flex justify-content-end"
    }, /*#__PURE__*/React.createElement("a", {
      className: "btn btn-primary btn-squared",
      href: generateSurveyLink(),
      target: "_blank",
      rel: "noopener noreferrer",
      "aria-label": "take survey"
    }, /*#__PURE__*/React.createElement(T, {
      source: "curie.take-survey"
    }))));
  };

  // show toast notification for the downloaded document
  useEffect(function () {
    if (![RUBRIQ_FEATURES.EDITING, RUBRIQ_FEATURES.TRANSLATION].includes(feature)) {
      return;
    }
    setTimeout(function () {
      setFeatureSurveyLastShownAt(feature, new Date());
      toast(/*#__PURE__*/React.createElement(ToastBody, null));
    }, RUBRIQ_FEATURE_SURVEY_DELAY_MS);
  }, [downloadedDocumentIdentity]);
  return /*#__PURE__*/React.createElement(ToastContainer, {
    className: "rubriq-feature-feedback-toast-container container pb-1",
    autoClose: false,
    position: "bottom-right",
    hideProgressBar: true,
    closeButton: false,
    draggable: false,
    closeOnClick: false
  });
};
export default RubriqFeatureFeedbackToastNotification;